/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.19.1
 * source: google/firestore/v1/bloom_filter.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
export class BitSequence extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        bitmap?: Uint8Array;
        padding?: number;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("bitmap" in data && data.bitmap != undefined) {
                this.bitmap = data.bitmap;
            }
            if ("padding" in data && data.padding != undefined) {
                this.padding = data.padding;
            }
        }
    }
    get bitmap() {
        return pb_1.Message.getFieldWithDefault(this, 1, new Uint8Array(0)) as Uint8Array;
    }
    set bitmap(value: Uint8Array) {
        pb_1.Message.setField(this, 1, value);
    }
    get padding() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set padding(value: number) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        bitmap?: Uint8Array;
        padding?: number;
    }): BitSequence {
        const message = new BitSequence({});
        if (data.bitmap != null) {
            message.bitmap = data.bitmap;
        }
        if (data.padding != null) {
            message.padding = data.padding;
        }
        return message;
    }
    toObject() {
        const data: {
            bitmap?: Uint8Array;
            padding?: number;
        } = {};
        if (this.bitmap != null) {
            data.bitmap = this.bitmap;
        }
        if (this.padding != null) {
            data.padding = this.padding;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.bitmap.length)
            writer.writeBytes(1, this.bitmap);
        if (this.padding != 0)
            writer.writeInt32(2, this.padding);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BitSequence {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BitSequence();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.bitmap = reader.readBytes();
                    break;
                case 2:
                    message.padding = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): BitSequence {
        return BitSequence.deserialize(bytes);
    }
}
export class BloomFilter extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        bits?: BitSequence;
        hash_count?: number;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("bits" in data && data.bits != undefined) {
                this.bits = data.bits;
            }
            if ("hash_count" in data && data.hash_count != undefined) {
                this.hash_count = data.hash_count;
            }
        }
    }
    get bits() {
        return pb_1.Message.getWrapperField(this, BitSequence, 1) as BitSequence;
    }
    set bits(value: BitSequence) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_bits() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get hash_count() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set hash_count(value: number) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data: {
        bits?: ReturnType<typeof BitSequence.prototype.toObject>;
        hash_count?: number;
    }): BloomFilter {
        const message = new BloomFilter({});
        if (data.bits != null) {
            message.bits = BitSequence.fromObject(data.bits);
        }
        if (data.hash_count != null) {
            message.hash_count = data.hash_count;
        }
        return message;
    }
    toObject() {
        const data: {
            bits?: ReturnType<typeof BitSequence.prototype.toObject>;
            hash_count?: number;
        } = {};
        if (this.bits != null) {
            data.bits = this.bits.toObject();
        }
        if (this.hash_count != null) {
            data.hash_count = this.hash_count;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_bits)
            writer.writeMessage(1, this.bits, () => this.bits.serialize(writer));
        if (this.hash_count != 0)
            writer.writeInt32(2, this.hash_count);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BloomFilter {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BloomFilter();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.bits, () => message.bits = BitSequence.deserialize(reader));
                    break;
                case 2:
                    message.hash_count = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): BloomFilter {
        return BloomFilter.deserialize(bytes);
    }
}
